import { InterfaceContext } from "../model/InterfaceProvider";
import { useContext } from "react";

const RemoveMapMarkerButton = ()=>{
const {unsetMarker,marker} = useContext(InterfaceContext);
// console.log(marker.center)

return (
<>
{marker.center.length>0 && 
<div id="removeMarkerBtn" onClick={unsetMarker}>Remove Marker</div>
}</>
)

}
export default RemoveMapMarkerButton;